export default {
  getHospitalIntermediate: '/hospital/api/hospital/{0}/service/{1}',
  getHospitalInformation: '/hospital/api/hospital/{0}', // 医院信息
  getHospitalAreaInformation: '/hospital/api/hos-areas', // 院区信息
  getOfflineTreeDepartInfoByCondition: '/hospital/api/snDeptSync/app/single/tree', // 单点医院业务科室信息列表（树形结构）
  getOfflineSingleDepartInfoByCondition: '/hospital/api/snDeptSync/app/single/info', // 单点医院业务科室信息详情（单条结构）
  getOnlineTreeDepartInfoByCondition: '/hospital/api/netExt/deptSync/tree', // 互联网医院业务科室信息列表（树形结构）
  getBasicDoctorInfoByCondition: '/hospital/api/snDoctorInfo/app/list', // 院内医生信息列表
  getBasicOnlineDoctorExtendInfoByCondition: '/hospital/api/netExt/doc/info', // 互联网医院院内医生扩展信息列表
  getOfflineDoctorInfoByCondition: '/hospital/api/snDoctorSync/app/single/list', // 单点医院业务医生信息列表
  getOnlineDoctorInfoByCondition: '/hospital/api/netExt/docSync/info', // 互联网医院业务医生信息列表
  getSearchDoctorInfoByCondition: '/hospital/api/snDoctorInfo/app/listForIds', // 搜索业务医生信息列表
  getOnlineDepartDoctorInfoByCondition: '/hospital/api/netExt/docSync/list', // 互联网医院科室业务医生信息列表
  getOfflineDepartScheduleInfoByCondition: '/hospital/api/snScheduleSync/app/single/listByDept', // 单点医院科室排班列表
  getOfflineDoctorScheduleInfoByCondition: '/hospital/api/snScheduleSync/app/single/listByDoc', // 单点医院医生排班列表
  getOfflineScheduleOtherNoByCondition: '/hospital/api/snScheduleTime/app/single/schTime/surplusNumber',
  getScheduleCandidateOtherNoByCondition: '/hospital/api/snScheduleTime/candidateRemain',
  getOfflineScheduleTimeByCondition: '/hospital/api/snScheduleTime/app/single/schTime/list',
  getCollectionInfoByCondition: '/hospital/api/getAllCollection/accountId', // 关注列表
  setCollection: '/hospital/api/cancelCollection', // 关注 or 取消关注
  getOnlineDoctorFunction: '/hospital/api/net_basicsInfo/doc_business', // 互联网医院医生开通功能
  getOnlineDoctorBusinessAreaDepart: '/hospital/api/netExt/docSync/hosAreaAndDept', // 互联网医院业务医生院区、科室信息
  getOnlineDoctorBusinessSchedule: '/hospital/api/snScheduleSync/app/visits', // 互联网医院业务医生排班信息
  getOnlineScheduleTimeByCondition: '/hospital/api/snScheduleTime/app/net/schTime/list',
  getEntireDoctorInfoByCondition: '/hospital/api/snDocDept/app/single/list', // 调取当前医生信息
  getOnlineDoctorTitleByBusiness: '/hospital/api/netExt/docSync/docTitles', // 互联网医院根据业务类型调取取医生职称列表
  pcEntireScheduleInfoByCondition: '/hospital/api/snScheduleSync/web/all' // [PC]科室排班接口
};
